import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    domainesList : [],
    selectedDomaine:{},
}
const domainesSlice = createSlice({
    name:'domaines',
    initialState,
    reducers:{
        setDomainesList:(state,{payload})=>{
            state.domainesList = payload
            state.selectedDomaine = payload[0]
        },
        setSelectedDomaine:(state,{payload})=>{
            state.selectedDomaine = payload
        },
    }
})

export const { setDomainesList,setSelectedDomaine} = domainesSlice.actions
export default domainesSlice.reducer